import { Component, EventEmitter, Output } from '@angular/core';
import { ProductivityEventsService } from '@app-services/productivity-events/productivity-events.service';

@Component({
  selector: 'app-date-filter',
  templateUrl: './date-filter.component.html',
  styleUrls: ['./date-filter.component.scss'],
})
export class DateFilterComponent {
  @Output() filterSelected = new EventEmitter<any>();
  public clearFilter = false;
  public dateText = '';
  public filtersData = {
    date: {
      startDate: '',
      endDate: '',
    },
  };
  public dateFilter = {
    startDate: '',
    endDate: '',
  };

  constructor(private productivityEventsService: ProductivityEventsService) {}

  selectedDate(date) {
    this.dateFilter = date;
    this.filtersData.date = date;
    this.detectingDate(this.dateFilter.startDate, this.dateFilter.endDate);
    this.emitEvent();
    this.clearFilter = false;
  }

  detectingDate(start, end) {
    if (start && end) {
      this.dateText = `${this.productivityEventsService.formatDate(
        start
      )} - ${this.productivityEventsService.formatDate(end)}`;
    } else {
      this.dateText = '';
    }
  }

  emitEvent() {
    this.filterSelected.emit(this.filtersData);
  }

  resetFilters() {
    this.emptyVariables();
    this.emitEvent();
  }

  emptyVariables() {
    this.filtersData = {
      date: {
        startDate: '',
        endDate: '',
      },
    };
    this.dateFilter = {
      startDate: '',
      endDate: '',
    };
    this.dateText = '';
    this.clearFilter = true;
  }
}
